import React from "react";
import { Card, Button, Row, Col, Accordion } from "react-bootstrap";

import "./VcCard.scss";

const VcCard = ({
  index,
  vcCode,
  assignmentDate,
  isSetupDay,
  setupTime,
  scheduledHours,
  hideHourDisclaimer,
  siteLocation,
  siteAddress,
  lead,
  coworkers,
  szsitename,
}) => {
  const mapsSelector = () => {
    const addressComponent = encodeURIComponent(siteAddress);
    const browserMapsUrl = `https://www.google.com/maps/dir/?api=1&destination=${addressComponent}`;
    const mobileMapsUrl = `maps://maps.google.com/maps?daddr=${addressComponent}`;
    if (
      navigator.platform.indexOf("iPhone") !== -1 ||
      navigator.platform.indexOf("iPad") !== -1 ||
      navigator.platform.indexOf("iPod") !== -1
    ) {
      window.open(mobileMapsUrl);
    } else {
      window.open(browserMapsUrl);
    }
  };
  return (
    <Card>
      <Card.Header>
        Vote Center Assignment
        <strong>
          {assignmentDate && !isSetupDay ? ` - ${assignmentDate}` : ""}
        </strong>
      </Card.Header>
      <Card.Body>
        <Card.Text as="div">
          <Row>
            <Col sm>
              {isSetupDay && (
                <div className="mb-2">
                  <h4 className="mb-3">Vote Center Setup Day</h4>
                  Vote Center Setup Time:&nbsp;
                  <ul>{setupTime ? <li>{setupTime}</li> : <li>N/A</li>}</ul>
                </div>
              )}
              {!isSetupDay && (
                <>
                  Your scheduled hours to work at the Vote Center are: &nbsp;
                  <ul>
                    {scheduledHours[0] && scheduledHours[1] ? (
                      <li>
                        {`${scheduledHours[0]} - ${scheduledHours[1]}`}
                        {!hideHourDisclaimer && (
                          <>
                            *
                            <br />
                            *You are scheduled to work until all voters have
                            been processed and the Vote Center has closed.
                          </>
                        )}
                      </li>
                    ) : (
                      <li>Hours unavailable</li>
                    )}
                  </ul>
                </>
              )}
              Your assigned location and address are:&nbsp;
              <ul>
                {szsitename ? <li>{szsitename}</li> : <li>No site location</li>}
                {siteAddress ? (
                  <li>{siteAddress}</li>
                ) : (
                  <li>No site address</li>
                )}
              </ul>
            </Col>
            <Col sm>
              <div className="mb-3">
                Site Location Info: {siteLocation ? siteLocation : <>N/A</>}
              </div>
              <div className="mb-3">
                Vote Center ID: {vcCode ? vcCode : <>N/A</>}
              </div>
              <div className="mb-3">VC Lead: {lead ? lead : <>N/A</>}</div>
              {coworkers.length > 0 && (
                <div>
                  <Accordion>
                    <Card>
                      <Accordion.Toggle as={Card.Header} eventKey="0">
                        Click to view VC CSRs ▼
                      </Accordion.Toggle>
                      <Accordion.Collapse eventKey="0">
                        <ul className="mt-2">
                          {coworkers.map((coworker, i) => {
                            return <li key={i}>{coworker}</li>;
                          })}
                        </ul>
                      </Accordion.Collapse>
                    </Card>
                  </Accordion>
                </div>
              )}
            </Col>
          </Row>
        </Card.Text>
      </Card.Body>
      <Card.Footer>
        <Button
          variant="primary"
          className="d-block mx-auto"
          onClick={mapsSelector}
        >
          Get Directions
        </Button>
      </Card.Footer>
    </Card>
  );
};

VcCard.defaultProps = {
  vcCode: "PLAC-002",
  assignmentDate: "Thurs 9am - 1pm",
  scheduledHours: "2/29/2020: 7:00 A.M. - 9:00 P.M.",
};

export default VcCard;
